const isMocked = process.env.TEST_ENV === "mock";

export const valid_username = isMocked ? "mock-user" : "seed-user-admin";
export const valid_password = "P4$$W0rd";
export const invalid_username = "fake-user";
export const invalid_password = "fake-password";
